import { getList, publicPage } from './geSettlementBillList'
import { deepClone } from '@/assets/js/utils'
import {
  settlementAdjust,
  initiateConfirmSettlement,
  revokeSettlement,
  initPaySettlement,
  statementExportPDF,
  statementExportExcel,
  getStatementInterviewers,
  wjSettleIsSign
} from '@/api/wenjuan/settlement'
import { getStore } from '@dygc/shared'
import GlobalConfig from '@/global/config'

export default {
  props: {
    searchField: {
      type: Array,
      default: () => []
    },
    forms: {
      type: Object,
      default: () => ({})
    },
    opt: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      queryFields: [],
      surveyId: '',
      settleType: 0,
      page: publicPage,
      sentData: {},
      diaBillTitle: {
        cancel: '撤销结算单确认',
        start: '发起结算单确认',
        pay: '线下支付确认'
      },
      dialogSettlementBillTitle: '生成结算单确认',
      dialogSettlementBillVisible: false,
      dialogTitle: '调整单价',
      dialogVisible: false,
      dialogUnitPrice: '',
      dialogType: '',
      dialogTypeSub: '',
      sheetNum: 0,
      sheetAmountSum: 0,
      totalYuanAmount: 0,
      visitorNum: 0,
      visitorName: '',
      billCode: '',
      dialogForm: {
        id: '',
        realAmount: '',
        adjustDescribe: ''
      },
      rules: {
        realAmount: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          {
            pattern: /^([1-9]\d{0,7}|0)(\.\d{1,2})?$/,
            message: '请输入有效的的金额'
          }
        ],
        adjustDescribe: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      },
      selectionList: [],
      selectionAmountList: [],
      statusFlag: {
        start: true,
        cancel: true,
        pay: true
      },
      data: [],
      option: this.opt,
      onlinePayVisible: false, // 线上支付 dialog
      onlinePayInfo: {}, // 信息
      approvalPayVisible: false, // 审核支付 dialog
      paymentInfo: {}, //支付审批信息
      includeStatementIds: '', // 审批详情包含的结算单ids，英文逗号分隔，目前只有一个id
      payApprovalDetailVisible: false, // 查看付款审核详情 dialog
      showCancelAudit: true, // 查看付款审批时是否显示撤销按钮
      isSign: null, //是否签约线上协议
      payApprovePayType: null //批量发起财务付款审批的“结算方式”
    }
  },
  methods: {
    toSettlementPayDetail(row) {
      this.includeStatementIds = row.id
      if (row.settleStatus == 8) {
        this.showCancelAudit = true
      } else if (row.settleStatus == 7) {
        this.showCancelAudit = false
      }
      this.payApprovalDetailVisible = true
      this.$nextTick(function () {
        this.$refs['s-approval'].getSettlementPayInfo()
      })
    },
    handlepayApprovalDetailClose() {
      this.payApprovalDetailVisible = false
      this.getList(this.handleData())
    },
    openDrawer(row) {
      this.settlementId = row.id
      this.drawer = true
      this.$nextTick(function () {
        this.$refs.detailDrawer.getSettlementDetail()
      })
    },
    wjSettleIsSign() {
      const companyId = GlobalConfig.getCompanyId()
      return wjSettleIsSign({ companyId }).then(res => {
        if (res.data.code == 0 && res.data.data == '已签约') {
          this.isSign = true
        }
      })
    },
    async saveComfirm() {
      if (this.dialogTypeSub === 'start') {
        await this.wjSettleIsSign()
        //线上结算
        if (this.paymentMethod == 2 && !this.isSign) {
          this.$message.warning('您还未与调研工厂签署服务协议，无法选择线上结算')
          return
        }
        initiateConfirmSettlement({
          ...this.sentData,
          payType: this.paymentMethod
        })
          .then(res => {
            this.dialogSettlementBillVisible = false
            this.getList(this.handleData())
            this.$message({
              showClose: true,
              message: '发起成功',
              type: 'success'
            })
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: '网络故障，请稍后再试',
              type: 'error'
            })
          })
      } else if (this.dialogTypeSub === 'cancel') {
        revokeSettlement(this.sentData)
          .then(res => {
            this.dialogSettlementBillVisible = false
            this.getList(this.handleData())
            this.$message({
              showClose: true,
              message: '撤销成功',
              type: 'success'
            })
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: '网络故障，请稍后再试',
              type: 'error'
            })
          })
      } else if (this.dialogTypeSub === 'pay') {
        this.sentData.payType = 0 //0线下1线上
        initPaySettlement(this.sentData)
          .then(res => {
            this.dialogSettlementBillVisible = false
            this.getList(this.handleData())
            this.$message({
              showClose: true,
              message: '确认成功',
              type: 'success'
            })
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: '网络故障，请稍后再试',
              type: 'error'
            })
          })
      }
    },
    generateSettlementBill() {
      this.dialogSettlementBillVisible = true
    },
    showSettlementBillDialog(row, type, bach) {
      this.paymentMethod = 1
      if (bach == 'bach') {
        if (this.selectionList.length <= 0) {
          this.$message.error('批量操作前请先进行选择')
          return
        }
        if (type == 'start' && this.statusFlag.start == false) {
          this.$message.error('含有不可发起确认的结算单，请检查')
          return
        }
        if (type == 'cancel' && this.statusFlag.cancel == false) {
          this.$message.error('含有不可撤销的结算单，请检查')
          return
        }
        if ((type == 'pay' || type == 'payOnline' || type == 'payApprove') && this.statusFlag.pay == false) {
          this.$message.error('含有不可支付的结算单，请检查')
          return
        }
        //发起财务付款审批时 验证所选列表是否为相同结算方式
        if (type == 'payApprove') {
          this.selectionList.forEach((item, index) => {
            let curPayType = this.data.find(data => data.id == item).payType
            if (index == 0) {
              this.payApprovePayType = curPayType
            } else {
              if (curPayType == this.payApprovePayType) {
                this.payApprovePayType = curPayType
              } else {
                this.payApprovePayType = null
                this.$message.error('请选择的结算方式相同的结算单')
                return
              }
            }
          })
          if (this.payApprovePayType == null) {
            return
          }
        }
      }
      this.dialogTypeSub = type
      this.visitorName = row.executorName
      this.billCode = row.id
      if (bach == 'bach') {
        this.dialogSettlementBillTitle = '批量' + this.diaBillTitle[type]
        this.dialogType = 'bach'
      } else {
        this.dialogSettlementBillTitle = this.diaBillTitle[type]
        this.dialogType = 'single'
      }
      let data = {
        settleType: this.settleType,
        surveyId: this.surveyId,
        statementIds: [row.id]
      }
      // 是否批量
      if (bach == 'bach') {
        data.statementIds = this.selectionList
      }
      this.sentData = data
      // if(type==='payOnline') {
      //   this.onlinePayInfo=row
      //   this.onlinePayVisible = true
      // } else {
      //   this.dialogSettlementBillVisible = true
      // }
      if (type === 'payApprove') {
        this.paymentInfo.row = row
        this.paymentInfo.bach = bach
        this.paymentInfo.sentData = this.sentData //批量id信息
        this.paymentInfo.sheetAmountSum = this.sheetAmountSum //批量合计金额
        this.paymentInfo.sheetAmount = row.realAmount //单独金额
        bach == 'single' && (this.payApprovePayType = row.payType)
        this.approvalPayVisible = true
      } else {
        this.dialogSettlementBillVisible = true
      }
    },
    showDialog(row) {
      this.dialogTitle = '调整结算费用'
      this.dialogUnitPrice = row.totalAmount
      this.dialogType = 'single'
      this.dialogVisible = true
      this.dialogForm.id = row.id
      this.visitorName = row.executorName + '（' + row.executorPhone + '）'
      this.sheetNum = row.answerNum
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs['dialogForm'].clearValidate()
      Object.assign(this.$data.dialogForm, this.$options.data().dialogForm)
    },
    handleSettlementBillClose() {
      this.dialogSettlementBillVisible = false
    },
    SelectionChange(val) {
      this.statusFlag = {
        start: true,
        cancel: true,
        pay: true
      }
      this.selectionList = val.map(el => {
        if (el.settleStatus != 1 && el.settleStatus != 3) {
          this.statusFlag.start = false
        }
        if (el.settleStatus == 5 || el.settleStatus == 6 || el.settleStatus == 7) {
          this.statusFlag.cancel = false
        }
        if (el.settleStatus != 4 && el.settleStatus != 9 && el.settleStatus != 10) {
          this.statusFlag.pay = false
        }
        return el.id
      })
      let num = 0
      let i = 0
      let selectionVisitorList = []
      this.selectionAmountList = val.map(el => {
        selectionVisitorList.push(el.executorId)
        num = num + Number(el.realAmount)
        i++
        return el.realAmount
      })
      this.sheetAmountSum = num.toFixed(2)
      this.sheetNum = i
      this.visitorNum = [...new Set(selectionVisitorList)].length
      console.log('this.selectionList', this.selectionList)
    },
    // 结算单调价
    editMoney() {
      this.$refs['dialogForm'].validate(valid => {
        if (valid) {
          this.dialogForm.settleType = this.settleType
          this.dialogForm.realYuanAmount = this.dialogForm.realAmount
          settlementAdjust(this.dialogForm)
            .then(res => {
              if (res.data.code != 0) {
                this.$message.error(res.data.msg)
                return
              }
              this.dialogVisible = false
              Object.assign(this.$data.dialogForm, this.$options.data().dialogForm)
              this.getList(this.handleData())
              this.$message({
                showClose: true,
                message: '结算单调价成功',
                type: 'success'
              })
            })
            .catch(err => {
              this.$message({
                showClose: true,
                message: '结算单调价失败',
                type: 'error'
              })
            })
        } else {
          return false
        }
      })
    },
    DownloadExportPDF() {
      statementExportPDF(this.handleData())
        .then(res => {
          window.open(res.data.data)
        })
        .catch(e => {
          console.log(e)
        })
    },
    DownloadExportDetailExcel() {
      statementExportExcel(this.handleData())
        .then(res => {
          window.open(res.data.data)
        })
        .catch(e => {
          console.log(e)
        })
    },
    getList(params, noClearSelection) {
      getList.call(this, params)
      if (!noClearSelection) {
        this.$refs.tableRef?.clearSelection()
      }
    },
    // 整理请求数据
    handleData() {
      const fs = deepClone(this.forms)
      fs.current = this.page.currentPage
      fs.size = this.page.pageSize
      fs.surveyId = GlobalConfig.getSurveyId()
      fs.settleType = this.settleType
      return fs
    },
    commonChange() {
      this.getList(this.handleData())
    },
    onChangeSearchField(params) {
      //params.interviewerArea = params.interviewerArea.join('/')
      if (params.executorIds) {
        params.executorIds = params.executorIds.join(',')
      }
      this.forms = params
      this.page.currentPage = 1
      this.getList(this.handleData())
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      //   重新渲染
      this.getList(this.handleData(), true)
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
      //   重新渲染
      this.getList(this.handleData(), true)
    },
    init() {
      this.page = {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        pageSizes: [10, 20, 30, 50, 100]
      }
      this.commonChange()
    },
    getStatementInterviewers() {
      let params = {
        surveyId: GlobalConfig.getSurveyId(),
        settleType: this.settleType
      }
      getStatementInterviewers(params)
        .then(res => {
          let data = res.data.data
          this.searchField[0].options = data.map(item => {
            let opItem = {}
            opItem.label = item.name || item.phone
            opItem.value = item.id
            return opItem
          })
          this.queryFields = deepClone(this.searchField)
        })
        .catch(err => {})
    }
  },
  created() {
    this.surveyId = GlobalConfig.getSurveyId()
    this.settleType = this.$route.query.settleType
    if (this.settleType == 2 || this.settleType == 3) {
      this.getStatementInterviewers()
    } else {
      this.queryFields = deepClone(this.searchField)
    }
    this.init()
  }
}
